import * as React from 'react';
import { classes } from '@bloomberg/media-ui-core';

import { BaseAd } from '../BaseAd/index';
import { GlobalAdProps } from '../types/index';

import styles from './BrokerBoxAd.module.css';

export type BrokerBoxAdProps = GlobalAdProps & {
  v2?: boolean;
};

export const BrokerBoxAd = React.forwardRef<HTMLDivElement, BrokerBoxAdProps>(
  function BrokerBoxAdComponent(
    { className, name = 'BrokerBoxAd', v2 = false, ...props }: BrokerBoxAdProps,
    ref
  ) {
    return (
      <BaseAd
        ref={ref}
        className={classes(
          [
            styles.brokerBoxAd,
            {
              [styles.versiontwo]: v2,
            },
          ],
          {
            className,
          }
        )}
        name={name}
        adType={v2 ? 'broker-box-v2' : 'broker-box'}
        {...props}
      />
    );
  }
);

export const CombinedBrokerBoxAd = React.forwardRef<
  HTMLDivElement,
  BrokerBoxAdProps
>(function CombinedBrokerBoxAdComponent(
  { className, name = 'CombinedBrokerBoxAd', ...props }: BrokerBoxAdProps,
  ref
) {
  return (
    <BaseAd
      ref={ref}
      className={classes(styles.combinedBrokerBoxAd, {
        className,
      })}
      name={name}
      adType="combined-broker-box"
      {...props}
    />
  );
});
